import React, { useState, useEffect } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { Outlet } from 'react-router-dom'
import { can, permissionForPath, firstAllowedPath } from '../../configTools/permissions'
import { refreshUserInfo } from '../../configTools/session'
import './index.css'
import Leftbar from './leftbar'
import 'react-toastify/dist/ReactToastify.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars } from '@fortawesome/free-solid-svg-icons'

const Index = () => {
    const User = JSON.parse(localStorage.getItem("user-info"));
    const [mobileopen,setMobileOpen] = useState(false);
    const location = useLocation();
    // Before the early returns below - hooks must run unconditionally on every render.
    // Re-reads role and permissions once per panel load so a change made by the lab owner takes
    // effect without the employee signing out. Only reloads if something actually differs.
    useEffect(()=>{ refreshUserInfo(); },[])
    if(!User){
        return <Navigate to={"/login"}/>
    }
    // Employees share this panel with the lab owner; which pages they actually see is decided
    // per route below and by the filtered sidebar.
    if(User.role !== 'labadmin' && User.role !== 'employee'){
        return <Navigate to={"/login"}/>
    }
    // Guarding here rather than only in the sidebar. Filtering the menu hides links but leaves
    // every page reachable by typing its URL - and four of them (shipping, accounts, vouchers,
    // transections) have no sidebar entry at all, so menu filtering would never cover them.
    // This is a convenience layer: the API enforces the same keys independently.
    const required = permissionForPath(location.pathname);
    if(!can(User,required)){
        const fallback = firstAllowedPath(User);
        // An employee granted nothing has nowhere to land - send them back to sign in rather
        // than looping between two pages they cannot open.
        return <Navigate to={fallback || "/login"} replace/>
    }
    return (
        <>
        <div className='admin_layout_container'>
            <Leftbar mobileopen={mobileopen} setMobileOpen={setMobileOpen}/>
            <div className='admin_layout_body_wrapper'>
                <div className='mobile_menu_opener'>
                    <button onClick={()=>{setMobileOpen(true)}}>
                        <FontAwesomeIcon icon={faBars}/>
                    </button>
                </div>
                <div className='admin_layout_body_container'>
                    <Outlet/>
                </div>
            </div>
        </div>
        </>
    )
}

export default Index
